import { FormattedMessage } from 'react-intl';
import { WLIDS } from 'Constants';
import LoginFlow from 'Views/Components/_HumanWritten/BookingWizard/FerryTripBookingWizard/WizardSteps/LoginStep/LoginFlow';
import { Button, Colors, Display } from 'Views/Components/Button/Button';
import { NewModal } from 'Views/Components/Modal/NewModal';
import LoaderInsideButton from 'Views/Components/Spinner/LoaderInsideButton';
import { useAnytimeTicketStore } from '../State/AnytimeTicketContext';
import { savePendingAnytimeTicketPurchase } from '../Utils/AnytimeTicketPurchasePendingFlag';

import { useEffect, useRef } from 'react';

export default function AnytimeTicketLoginStep() {
	const completeLogin = useAnytimeTicketStore(s => s.completeLogin);
	const setRegistrationComplete = useAnytimeTicketStore(s => s.setRegistrationComplete);
	const setLoginMode = useAnytimeTicketStore(s => s.setLoginMode);
	const setLoginLoading = useAnytimeTicketStore(s => s.setLoginLoading);
	const setLoginResetFn = useAnytimeTicketStore(s => s.setLoginResetFn);

	const resetRef = useRef<(() => void) | null>(null);

	useEffect(() => {
		setLoginResetFn(() => resetRef.current?.());
		return () => setLoginResetFn(null);
	}, [setLoginResetFn]);

	return (
		<div className="purchase-gift-voucher__login">
			<LoginFlow
				afterLoginSuccess={completeLogin}
				formId="purchase-voucher-login"
				registrationMessage={<FormattedMessage {...WLIDS.auth.voucherRegistrationDescription} />}
				onRegistrationComplete={() => {
					setRegistrationComplete(true);
					savePendingAnytimeTicketPurchase();
				}}
				onModeChange={setLoginMode}
				onLoadingChange={setLoginLoading}
				resetRef={resetRef}
			/>
		</div>
	);
}

interface FooterProps {
	onCancel: () => void;
	onDone: () => void;
	scrollToTop: () => void;
}

AnytimeTicketLoginStep.Footer = function AnytimeTicketLoginFooter({ onCancel, onDone }: FooterProps) {
	const loginMode = useAnytimeTicketStore(s => s.loginMode);
	const registrationComplete = useAnytimeTicketStore(s => s.registrationComplete);
	const loginLoading = useAnytimeTicketStore(s => s.loginLoading);
	const triggerLoginReset = useAnytimeTicketStore(s => s.triggerLoginReset);

	const showBack = loginMode !== 'initial' && !registrationComplete;

	return (
		<NewModal.Footer>
			{showBack ? (
				<Button
					display={Display.Outline}
					colors={Colors.Grey}
					newStyles
					onClick={triggerLoginReset}
					disabled={loginLoading}
				>
					Back
				</Button>
			) : (
				<Button
					display={Display.Outline}
					colors={Colors.Grey}
					newStyles
					// Login is the first step for a logged-out user (no transaction started yet), so
					// Cancel should close the modal. abortPurchase resets to 'select_product' when
					// loginMode is 'initial', which would wrongly advance them to product selection.
					onClick={onCancel}
					disabled={loginLoading}
				>
					Cancel
				</Button>
			)}
			{registrationComplete ? (
				<Button display={Display.Solid} colors={Colors.Primary} newStyles onClick={onDone}>
					Done
				</Button>
			) : (
				<Button
					display={Display.Solid}
					colors={Colors.Primary}
					newStyles
					type="submit"
					disabled={loginLoading}
					buttonProps={{
						form: 'purchase-voucher-login',
					}}
				>
					Continue
					{loginLoading && <LoaderInsideButton />}
				</Button>
			)}
		</NewModal.Footer>
	);
};
